import type { CommunicationRecord } from "@entities";

export const COMMUNICATION_RECORDS_PREVIEW_LIMIT = 3;

export function getLatestCommunicationRecord(
  records: CommunicationRecord[] | undefined,
): CommunicationRecord | undefined {
  if (!records?.length) return undefined;

  return records.reduce<CommunicationRecord | undefined>((latest, record) => {
    if (!latest) return record;
    return new Date(record.createdAt).getTime() > new Date(latest.createdAt).getTime()
      ? record
      : latest;
  }, undefined);
}

export function formatCommunicationRecordDate(
  record: CommunicationRecord | undefined,
): string {
  if (!record?.createdAt) return "-";

  return new Date(record.createdAt).toLocaleDateString("he-IL", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}
